import { actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  cposDetail: {},
  cposCount: null,
  cposList: [],
  cpos_groupsList: [],
  list_cposList: [],
  cposSequencesList: [],
  retrieveLoader: false,
  createLoader: false,
  deleteLoader: false
}

const getters = {
  orgunits: state => {
    return state.orgunitsList
  }
}

export default {
  actions: actionsAbstract,
  getters,
  mutations: mutationsAbstract,
  namespaced: true,
  state
}
